
export const BASE_URL_API_TRANXT_UAT_API = `https://payroll.billpunch.com`;


export const BASE_URL_PAYNOW = `https://apitranxt.paynnow.com`
